"use client";

import { JSX, ReactNode } from "react";
import { cn } from "~/lib/utils";
import Badge from "~/componentsDS/Badge";
import { QuizCTA } from "~/components/features/quiz";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";
import { hiwData } from "../data/hiw-data";
import HowItWorksSteps from "../menopause/components/HowItWorksSteps";
import useFlag from "~/hooks/useFlag";
import { GET_STARTED_REDESIGN } from "~/constants/flags";
import GetStarted from "~/componentsDS/GetStarted";

export type StepItem = {
    imageUrl: string;
    icon: JSX.Element;
    title: string;
    description: ReactNode;
}

type Props = {
    heading?: ReactNode;
    steps?: StepItem[];
    className?: string;
    classNameCarousel?: string;
    hiddenLabel?: boolean;
    CTA_TITLE?: string;
}

const defaultCtaTitle = "See If Oestra® Is Right for You"

const HowItWorksSection = ({
    heading = "Getting started is simple",
    steps = hiwData,
    className,
    classNameCarousel,
    hiddenLabel = false,
    CTA_TITLE=defaultCtaTitle
}: Props) => {
    const variant = useFlag(GET_STARTED_REDESIGN);
    const isRedesign = Boolean(variant);

    return (
        <section className={cn("pt-8 md:pt-0 pb-0 md:pb-[41px]", className)} >
            <ElementorContainer innerClassName="flex flex-col">
                <Reveal>
                    <Badge className="mb-4 font-medium">How it works</Badge>
                    <Heading as="h2" size="sm" sizes={{md: "md"}} className="mb-8 text-primary500">
                        {heading}
                    </Heading>
                </Reveal>
            </ElementorContainer>

            {isRedesign
                ? <GetStarted isElementorContainer/>
                : <HowItWorksSteps steps={steps} classNameCarousel={classNameCarousel} />
            }

            <ElementorContainer className="mt-6 md:mt-[40px]" innerClassName="flex flex-col">
                <div className="max-[390px]:pt-4 flex flex-col items-center">
                    <QuizCTA
                        variant="primary"
                        eventData={{
                            widget: "lp_steps",
                            event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                            meta_data: {
                                click_text: CTA_TITLE,
                            },
                        }}
                        href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                        size="md"
                    >
                        <span className="inline-block">
                            <TextWithRegisteredMark text={CTA_TITLE} />
                        </span>
                    </QuizCTA>

                    {!hiddenLabel && (<Paragraph className="text-gray400 mt-2" size="xs">Free shipping. Cancel anytime. HSA/FSA Eligible.</Paragraph>)}
                </div>
            </ElementorContainer>
        </section>
    )
};

export default HowItWorksSection;
